class MassiveDownloadPostSaveUserConfig {
  constructor ({ selectedGranularity, dynamicDateMapId, selectedDateFrom, selectedDateTo, selectedProductDimensionIds, selectedStoreDimensionIds, reportName, reportDescription, defaultSelectionDeepCopy }) {
    this.granularity = selectedGranularity
    this.dynamicDateMapId = dynamicDateMapId
    this.dateFrom = new Date(selectedDateFrom).getTime()
    this.dateTo = new Date(selectedDateTo).getTime()
    this.productDimensionIds = selectedProductDimensionIds
    this.storeDimensionIds = selectedStoreDimensionIds
    this.reportName = reportName
    this.reportDescription = reportDescription
    this.defaultSelection = defaultSelectionDeepCopy
  }

  get body () {
    this.defaultSelection.requiredSelection.granularity.options = this.userConfigGranularityOptions
    this.defaultSelection.requiredSelection.dateSelection.dynamicDate.options = this.userConfigDynamicDateOptions
    this.defaultSelection.columnSelection.productDimensions.options = this.userConfigProductDimenionOptions
    this.defaultSelection.columnSelection.storeDimensions.options = this.userConfigStoreDimenionOptions
    this.defaultSelection.requiredSelection.dateSelection.customDate.from = this.dateFrom
    this.defaultSelection.requiredSelection.dateSelection.customDate.to = this.dateTo
    return {
      metadata: {
        name: this.reportName,
        description: this.reportDescription
      },
      parameters: {
        ...this.defaultSelection
      }
    }
  }

  get userConfigGranularityOptions () {
    return this.defaultSelection.requiredSelection.granularity.options
      .map((option) => this.changeSelectedOption(option, (option.id === this.granularity.id)))
  }

  get userConfigDynamicDateOptions () {
    return this.defaultSelection.requiredSelection.dateSelection.dynamicDate.options
      .map((option) => this.changeSelectedOption(option, [...this.dynamicDateMapId.values()].includes(option.id)))
      .map(option => ({ ...option, from: undefined, to: undefined }))
  }

  get userConfigProductDimenionOptions () {
    return this.defaultSelection.columnSelection.productDimensions.options
      .map((option) => this.changeSelectedOption(option, this.productDimensionIds.includes(option.value)))
  }

  get userConfigStoreDimenionOptions () {
    return this.defaultSelection.columnSelection.storeDimensions.options
      .map((option) => this.changeSelectedOption(option, this.storeDimensionIds.includes(option.value)))
  }

  changeSelectedOption (option, rule) {
    return rule ? { ...option, selected: true } : { ...option, selected: false }
  }
}

export default MassiveDownloadPostSaveUserConfig



// WEBPACK FOOTER //
// ./src/app/massive_download/models/MassiveDownloadPostSaveUserConfig.js